#@export GliveBooking.Presenters.Quantity

class GliveBooking.Presenters.Quantity extends BookingV2.Presenters.Base

  module: 'glive-booking'

  toHash: ->
    if(@model)
      selected: @options.selected?.getPartySize() == @model.getPartySize()
      quantity: @model.getPartySize()

  bhc: ->
    "partysize:#{@model.getPartySize()}"
